@import '../../global/global.scss';

@mixin message-border {
    border-radius: var(--stamp-radius-s, 6px);
    border: none;
}

#webchatWindow {
    bottom: calc(var(--position-bottom-offset, 14px) + var(--size-toggle-button, 48px) + var(--stamp-spacing-inner-l, 16px));
}

// Toggle button
[data-cognigy-webchat-root] button[data-cognigy-webchat-toggle].webchat-toggle-button {
    display: none; // Initialy hidden, ultimately determined on load
    width: var(--size-toggle-button, 48px);
    height: var(--size-toggle-button, 48px);
    border: 1px solid var(--stamp-color-border-button-secondary-default, #6161FF);
    background: var(--stamp-color-background-switchButton-active-disabled, #F1F1F2);
    box-shadow: 0px 2px 6px 0px rgba(31, 30, 47, 0.15);
    bottom: var(--position-bottom-offset, 14px);

    &:focus {
        box-shadow: 0px 2px 6px 0px rgba(31, 30, 47, 0.15);
    }

    // Hide default icon
    svg {
        display: none;
    }

    &::after {
        content: '';
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="37" height="33" viewBox="0 0 37 33" fill="none"><g id="Illustration/Daan/chat"><g id="Group 2"><g id="Basis"><g id="Group"><path id="Path" d="M19.255 31.0069C24.8857 31.6819 35.2299 18.6698 34.5122 14.6853C33.7944 10.7009 26.2442 8.99222 26.2442 8.99222C26.2442 8.99222 14.82 5.83556 12.1293 9.98467C9.43867 14.1338 15.1707 30.5182 19.255 31.0069Z" fill="%23FF8D00"/><path id="Path_2" d="M28.729 25.1938C32.1936 21.4016 34.8959 16.783 34.5167 14.6804C33.7982 10.7016 26.2487 8.98723 26.2487 8.98723C26.2487 8.98723 14.8246 5.83058 12.1339 9.97968L28.729 25.1938Z" fill="%23F56900"/><g id="Oval" style="mix-blend-mode:multiply" opacity="0.7"><path d="M21.315 23.6749C24.2961 24.0939 27.0524 22.0168 27.4714 19.0357C27.8904 16.0545 25.8133 13.2982 22.8322 12.8792C19.851 12.4602 17.0947 14.5373 16.6757 17.5184C16.2568 20.4996 18.3338 23.2559 21.315 23.6749Z" fill="%23EBECEF"/></g><path id="Path (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M19.7077 12.3233C19.7079 12.3233 19.7081 12.3232 19.5598 11.8005C19.4116 11.2777 19.4118 11.2777 19.4121 11.2776L19.4126 11.2775L19.4139 11.2771L19.4174 11.2761C19.42 11.2754 19.4235 11.2745 19.4276 11.2733C19.436 11.2711 19.4473 11.2681 19.4615 11.2645C19.4898 11.2573 19.5298 11.2476 19.5807 11.2363C19.6824 11.2136 19.8281 11.1845 20.0128 11.1559C20.382 11.0988 20.9082 11.0439 21.5514 11.0486C22.8383 11.058 24.5976 11.3063 26.5007 12.2557L26.0156 13.2281C24.2879 12.3662 22.698 12.1438 21.5434 12.1353C20.966 12.1311 20.4984 12.1804 20.1789 12.2298C20.0193 12.2545 19.897 12.2792 19.8168 12.297C19.7767 12.3059 19.7472 12.3132 19.7289 12.3178C19.7197 12.3201 19.7134 12.3218 19.7099 12.3228L19.7069 12.3236L19.7074 12.3234L19.7077 12.3233ZM19.7068 12.3236L19.7069 12.3236C19.7067 12.3236 19.7066 12.3236 19.7068 12.3236Z" fill="%23FDD732"/><path id="Path_3" fill-rule="evenodd" clip-rule="evenodd" d="M23.6818 25.8791C22.6576 26.2683 20.3192 26.5944 18.3891 24.7527C18.503 26.14 19.1955 27.0346 20.4665 27.4365C21.7375 27.8384 22.8092 27.3193 23.6818 25.8791Z" fill="%23001A73"/><path id="Path (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M18.1691 24.2918C18.3604 24.2005 18.5883 24.2369 18.7417 24.3832C20.4784 26.0405 22.5835 25.7502 23.5003 25.4017C23.7041 25.3243 23.9346 25.3847 24.0742 25.5522C24.2137 25.7197 24.2316 25.9573 24.1186 26.1438C23.6515 26.9148 23.1004 27.4914 22.4462 27.8082C21.7785 28.1317 21.0564 28.1587 20.3125 27.9235C19.5961 27.6969 19.0106 27.3201 18.59 26.7768C18.1707 26.235 17.9433 25.5639 17.8801 24.7945C17.8627 24.5832 17.9777 24.3832 18.1691 24.2918ZM19.3313 26.0605C19.3527 26.0917 19.3749 26.122 19.3978 26.1516C19.6697 26.5028 20.066 26.7742 20.6205 26.9496C21.1477 27.1163 21.5969 27.0847 22.0009 26.889C22.1153 26.8336 22.2298 26.7632 22.3443 26.6764C21.4566 26.7396 20.3854 26.6163 19.3313 26.0605Z" fill="%23001A73"/><g id="Path_4" style="mix-blend-mode:multiply"><path d="M21.3979 9.17984C21.4485 9.01246 21.7272 8.69876 22.6728 8.84133C23.3762 8.9402 23.7449 9.39336 23.767 9.56709L21.3979 9.17984Z" fill="%23F7F7F8"/></g><path id="Path (Stroke)_3" fill-rule="evenodd" clip-rule="evenodd" d="M23.9822 6.70842C23.895 6.11241 23.7467 5.52694 23.5398 4.96125L22.9267 5.18554C23.1186 5.70994 23.2559 6.2527 23.3366 6.80524L23.337 6.80777L23.3374 6.81029C23.4817 7.70081 23.3453 8.74643 23.2213 9.47716L23.865 9.58634C23.9895 8.85195 24.1446 7.71403 23.9822 6.70842Z" fill="%23303DB9"/><path id="Oval_2" d="M23.39 6.63505C24.4684 6.78661 25.4655 6.03525 25.617 4.95683C25.7686 3.87841 25.0172 2.88131 23.9388 2.72975C22.8604 2.57819 21.8633 3.32955 21.7117 4.40797C21.5602 5.48639 22.3115 6.48349 23.39 6.63505Z" fill="%23F56900"/><path id="Oval_3" d="M21.3955 23.1026C24.0605 23.4771 26.5246 21.6203 26.8992 18.9552C27.2737 16.2902 25.4169 13.8261 22.7518 13.4515C20.0868 13.0769 17.6227 14.9338 17.2481 17.5989C16.8735 20.2639 18.7304 22.728 21.3955 23.1026Z" fill="white"/><path id="Oval_4" d="M20.2252 19.8476C21.605 20.0416 22.8808 19.0802 23.0747 17.7004C23.2686 16.3207 22.3073 15.0449 20.9275 14.851C19.5477 14.6571 18.272 15.6184 18.078 16.9982C17.8841 18.378 18.8455 19.6537 20.2252 19.8476Z" fill="%23001A73"/></g></g><g id="Chat bubble"><path id="Fill 1" fill-rule="evenodd" clip-rule="evenodd" d="M19.0655 5.99755C19.4829 8.96756 18.02 11.578 14.6762 13.0363L14.6817 13.1368C14.7387 14.0857 14.9131 14.8891 15.6798 15.3809C13.9487 15.6367 12.9083 14.676 12.3952 13.8734L12.155 13.9261C11.7721 14.0092 11.1832 14.1331 10.9272 14.1691C5.89767 14.876 1.38705 12.3636 0.852103 8.55728C0.317201 4.75126 3.96056 1.09271 8.99027 0.385826C14.0202 -0.321083 18.5306 2.19131 19.0655 5.99755Z" fill="%23303DB9"/><path id="Shape" fill-rule="evenodd" clip-rule="evenodd" d="M5.71095 6.88698C6.37342 6.88698 6.91046 7.42401 6.91046 8.08648C6.91046 8.74895 6.37342 9.28599 5.71095 9.28599C5.04848 9.28599 4.51144 8.74895 4.51144 8.08648C4.51144 7.42401 5.04848 6.88698 5.71095 6.88698ZM9.93778 6.20155C10.6002 6.20155 11.1373 6.73858 11.1373 7.40105C11.1373 8.06352 10.6002 8.60056 9.93778 8.60056C9.27531 8.60056 8.73828 8.06352 8.73828 7.40105C8.73828 6.73858 9.27531 6.20155 9.93778 6.20155ZM14.1646 5.51611C14.8271 5.51611 15.3641 6.05315 15.3641 6.71562C15.3641 7.37809 14.8271 7.91513 14.1646 7.91513C13.5021 7.91513 12.9651 7.37809 12.9651 6.71562C12.9651 6.05315 13.5021 5.51611 14.1646 5.51611Z" fill="white"/></g></g></g></svg>');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 90%;
        position: absolute;
        top: 0;
        right: 0;
        left: 5px; // Small offset cause Daan is symmetrically challenged
        bottom: 0;
    }

    .webchat-unread-message-badge {
        background-color: var(--stamp-color-background-notification, red);
        width: 25px;
        height: 25px;
        top: -7px;
        right: -7px;
        font-size: 1rem;
        font-weight: 400;
    }
}

// Toggle button - Overrides when chat is open
[data-cognigy-webchat-root]:has(#webchatWindow) {

    // Hide scroll button
    button.webchat-scroll-to-bottom-button {
        display: none;
    }

    button.webchat-toggle-button::after {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="32" viewBox="0 0 28 32" fill="none"><g id="Neutraal"><path id="Path" d="M12.716 31.7899C20.8227 31.7899 28.2702 16.479 26.8622 12.1995C25.4542 7.92005 16.8696 7.20752 16.8696 7.20752C16.8696 7.20752 3.79444 5.50299 1.46484 10.4865C-0.864758 15.4699 4.75017 31.7899 12.716 31.7899Z" fill="%23FF8D00"/><path id="Path_2" d="M22.4376 24.8971C26.0643 19.8902 27.6088 14.4545 26.8664 12.1953C25.4605 7.9158 16.876 7.20326 16.876 7.20326C16.876 7.20326 3.79867 5.4966 1.4776 10.4822" fill="%23F56900"/><g id="Path_3" style="mix-blend-mode:multiply"><path d="M11.562 8.17406C11.5919 7.98206 11.85 7.5938 12.9124 7.60446C13.7039 7.60446 14.1796 8.0482 14.2308 8.24446L11.562 8.17406Z" fill="%23F7F7F8"/></g><path id="Path (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M14.0252 5.04387C13.8352 4.401 13.5811 3.77885 13.2667 3.18677L12.626 3.52694C12.918 4.07676 13.1539 4.65455 13.3303 5.25158L13.3309 5.25386L13.3316 5.25612C13.6281 6.21362 13.6398 7.38731 13.6164 8.21055L14.3414 8.23116C14.3649 7.40378 14.3595 6.12535 14.0252 5.04387Z" fill="%23303DB9"/><path id="Oval" d="M13.3602 5.05288C14.5714 5.05288 15.5533 4.07101 15.5533 2.85981C15.5533 1.64862 14.5714 0.666748 13.3602 0.666748C12.149 0.666748 11.1672 1.64862 11.1672 2.85981C11.1672 4.07101 12.149 5.05288 13.3602 5.05288Z" fill="%23F56900"/><g id="Oval_2" style="mix-blend-mode:multiply"><path d="M13.469 24.4789C16.8375 24.4789 19.5682 21.7482 19.5682 18.3797C19.5682 15.0112 16.8375 12.2805 13.469 12.2805C10.1005 12.2805 7.36981 15.0112 7.36981 18.3797C7.36981 21.7482 10.1005 24.4789 13.469 24.4789Z" fill="%23EBECEF"/></g><path id="Oval_3" d="M13.5117 23.6875C16.443 23.6875 18.8194 21.3111 18.8194 18.3798C18.8194 15.4484 16.443 13.072 13.5117 13.072C10.5803 13.072 8.20392 15.4484 8.20392 18.3798C8.20392 21.3111 10.5803 23.6875 13.5117 23.6875Z" fill="white"/><path id="Oval_4" d="M13.5096 21.1189C15.0236 21.1189 16.2509 19.8916 16.2509 18.3776C16.2509 16.8636 15.0236 15.6362 13.5096 15.6362C11.9956 15.6362 10.7682 16.8636 10.7682 18.3776C10.7682 19.8916 11.9956 21.1189 13.5096 21.1189Z" fill="%23001A73"/><path id="Path (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M10.1541 12.1522C10.1542 12.1522 10.1544 12.1521 9.93833 11.5872C9.72225 11.0223 9.72245 11.0223 9.72267 11.0222L9.72317 11.022L9.72444 11.0215L9.72798 11.0202L9.73909 11.016C9.74827 11.0126 9.76099 11.008 9.77714 11.0022C9.80944 10.9907 9.85548 10.9746 9.91439 10.9552C10.0322 10.9162 10.2016 10.8634 10.4158 10.8053C10.8437 10.689 11.4526 10.5506 12.1861 10.4584C13.6489 10.2744 15.6346 10.2709 17.6732 11.0195L17.2562 12.155C15.4548 11.4934 13.6773 11.4899 12.337 11.6585C11.6689 11.7425 11.1161 11.8685 10.7329 11.9726C10.5414 12.0246 10.3929 12.071 10.2941 12.1036C10.2447 12.12 10.2078 12.1328 10.1842 12.1413C10.1724 12.1455 10.164 12.1486 10.159 12.1504L10.1541 12.1522ZM10.1538 12.1523L10.1541 12.1522C10.1538 12.1523 10.1537 12.1524 10.1536 12.1524L10.1538 12.1523ZM10.1536 12.1524C10.1536 12.1524 10.1536 12.1524 10.1536 12.1524L10.1536 12.1524Z" fill="%23FDD732"/><path id="Path (Stroke)_3" fill-rule="evenodd" clip-rule="evenodd" d="M9.19225 25.14C9.37749 24.9035 9.71941 24.8619 9.95596 25.0471C11.6128 26.3445 13.2061 26.3568 14.3978 26.0552C15.0011 25.9025 15.5036 25.6678 15.8552 25.4707C16.0304 25.3725 16.1664 25.2846 16.2566 25.2228C16.3017 25.1919 16.3352 25.1676 16.3564 25.1519C16.367 25.1441 16.3745 25.1384 16.3787 25.1351L16.3825 25.1322L16.3822 25.1324M16.3822 25.1324C16.3821 25.1325 16.382 25.1326 16.3818 25.1327L16.7203 25.5586C16.3818 25.1327 16.382 25.1326 16.3822 25.1324ZM16.3828 25.1319C16.618 24.9459 16.9595 24.9853 17.1462 25.2202C17.3331 25.4554 17.294 25.7976 17.0588 25.9845L16.7227 25.5617C17.0588 25.9845 17.0585 25.9847 17.0583 25.9849L17.0578 25.9853L17.0564 25.9864L17.0528 25.9892C17.05 25.9914 17.0463 25.9943 17.0417 25.9978C17.0326 26.0048 17.0202 26.0142 17.0045 26.0259C16.973 26.0492 16.9284 26.0814 16.8715 26.1204C16.7578 26.1983 16.5942 26.3038 16.3873 26.4197C15.9747 26.651 15.3827 26.9283 14.6647 27.11C13.2137 27.4772 11.2571 27.4479 9.28517 25.9037C9.04862 25.7185 9.00702 25.3766 9.19225 25.14" fill="%23001A73"/></g></svg>');
        background-size: 65%;
        left: 2px;
        bottom: 2px;
    }

    // Override - Chatting to CS
    &:has(.webchat-avatar.agent) {
        button.webchat-toggle-button {
            background-color: var(--stamp-color-illustration-yellow, #FDD732);

            &::after {
                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="34" height="40" viewBox="0 0 34 40" fill="none"><g id="Helpdesk vrouw"><g id="Group"><path id="Vector" d="M33.0533 39.2346C33.0533 34.0986 25.7613 29.9359 16.7653 29.9359C7.76934 29.9359 0.477341 34.0986 0.477341 39.2346C0.477341 39.2359 0.477341 39.2386 0.477341 39.2399H0.466675V49.4972H33.0413V39.5852C33.0493 39.4692 33.0547 39.3519 33.0547 39.2346H33.0533Z" fill="%236161FF"/><g id="Group_2"><path id="Vector_2" d="M22.5307 9.62396C25.5565 9.62396 28.0093 7.17108 28.0093 4.14529C28.0093 1.11951 25.5565 -1.33337 22.5307 -1.33337C19.5049 -1.33337 17.052 1.11951 17.052 4.14529C17.052 7.17108 19.5049 9.62396 22.5307 9.62396Z" fill="%230E0F1B"/><g id="Group_3"><g id="Group_4"><path id="Vector_3" d="M21.8713 32.1466C21.9182 30.4852 19.8034 29.0775 17.1476 29.0024C14.4918 28.9273 12.3008 30.2132 12.2538 31.8746C12.2068 33.5359 14.3216 34.9436 16.9774 35.0187C19.6332 35.0938 21.8243 33.8079 21.8713 32.1466Z" fill="%238F4E25"/><path id="Vector_4" d="M21.068 25.0479L21.8707 31.9159L12.264 31.7465L13.2507 24.0305L21.068 25.0479Z" fill="%238F4E25"/></g><g id="Group_5"><path id="Vector_5" d="M25.2328 17.5649C25.3911 11.9684 21.9809 7.33151 17.6159 7.20806C13.2509 7.08461 9.58407 11.5214 9.42579 17.1178C9.26752 22.7143 12.6777 27.3512 17.0427 27.4746C21.4077 27.5981 25.0745 23.1613 25.2328 17.5649Z" fill="%23A86231"/><path id="Vector_6" d="M20.144 18.1946C20.535 18.1946 20.852 17.8776 20.852 17.4866C20.852 17.0955 20.535 16.7786 20.144 16.7786C19.753 16.7786 19.436 17.0955 19.436 17.4866C19.436 17.8776 19.753 18.1946 20.144 18.1946Z" fill="%230E0F1B"/><path id="Vector_7" d="M14.1053 18.1946C14.4964 18.1946 14.8133 17.8776 14.8133 17.4866C14.8133 17.0955 14.4964 16.7786 14.1053 16.7786C13.7143 16.7786 13.3973 17.0955 13.3973 17.4866C13.3973 17.8776 13.7143 18.1946 14.1053 18.1946Z" fill="%230E0F1B"/><path id="Vector_8" d="M25.2413 16.1052C25.2413 16.1052 19.9933 11.6692 12.7973 10.2079C12.7053 10.1892 10.94 11.2719 10.2547 13.2919C8.92934 17.1986 9.55067 18.3239 9.55067 18.3239C9.55067 18.3239 7.66534 14.6492 7.71067 12.6972C7.87334 5.71724 17.0173 2.4719 21.724 5.35724C22.62 5.90657 27.0987 7.88257 26.16 13.8332C25.868 15.6826 25.24 16.1052 25.24 16.1052H25.2413Z" fill="%230E0F1B"/></g></g></g><g id="Group_6"><path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M6.91867 20.5319V26.2865C6.91867 26.5749 7.15697 26.8132 7.44534 26.8132H15.344V27.4879H7.44534C6.78437 27.4879 6.244 26.9475 6.244 26.2865V20.5319H6.91867Z" fill="%23E75204"/><path id="Vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M10.4171 9.13394C8.7229 10.3459 7.66133 12.2357 7.66133 14.9986V16.4546H6.98666V14.9986C6.98666 12.0361 8.1391 9.93396 10.0246 8.58522C11.8929 7.24872 14.4446 6.67725 17.2147 6.67725C19.9847 6.67725 22.5364 7.24872 24.4048 8.58522C26.2902 9.93396 27.4427 12.0361 27.4427 14.9986V16.3759H26.768V14.9986C26.768 12.2357 25.7064 10.3459 24.0122 9.13394C22.3009 7.90977 19.9073 7.35191 17.2147 7.35191C14.5221 7.35191 12.1284 7.90977 10.4171 9.13394Z" fill="%23E75204"/><g id="Group_7"><path id="Vector_9" d="M25.7907 14.6532H25.676C24.863 14.6532 24.204 15.3122 24.204 16.1252V21.2092C24.204 22.0222 24.863 22.6812 25.676 22.6812H25.7907C26.6036 22.6812 27.2627 22.0222 27.2627 21.2092V16.1252C27.2627 15.3122 26.6036 14.6532 25.7907 14.6532Z" fill="%23303DB9"/><path id="Vector_10" d="M26.9173 15.2318C28.8147 15.2318 30.352 16.7691 30.352 18.6665C30.352 20.5638 28.8147 22.1011 26.9173 22.1011" fill="%236161FF"/></g><g id="Group_8"><path id="Vector_11" d="M8.70934 22.6812H8.82401C9.63697 22.6812 10.296 22.0221 10.296 21.2092V16.1252C10.296 15.3122 9.63697 14.6532 8.82401 14.6532H8.70934C7.89638 14.6532 7.23734 15.3122 7.23734 16.1252L7.23734 21.2092C7.23734 22.0221 7.89638 22.6812 8.70934 22.6812Z" fill="%23303DB9"/><path id="Vector_12" d="M7.58401 15.2318C5.68667 15.2318 4.14934 16.7691 4.14934 18.6665C4.14934 20.5638 5.68667 22.1011 7.58401 22.1011" fill="%236161FF"/></g><path id="Vector_13" d="M15.3893 28.9986C16.3923 28.9986 17.2053 28.1855 17.2053 27.1826C17.2053 26.1796 16.3923 25.3666 15.3893 25.3666C14.3864 25.3666 13.5733 26.1796 13.5733 27.1826C13.5733 28.1855 14.3864 28.9986 15.3893 28.9986Z" fill="%230E0F1B"/></g></g><path id="Vector_14" d="M14.636 22.9012C15.66 23.3066 17.5533 23.6519 19.112 23.0026L14.636 22.9012Z" fill="white"/></g></svg>');
                background-size: contain;
                left: 0;
                bottom: 0;
                border-radius: 100%;
                border: var(--stamp-radius-xs, 4px) solid var(--stamp-color-background-switchButton-active-disabled, #F1F1F2);
            }
        }
    }
}

[data-cognigy-webchat-root] [data-cognigy-webchat] {
    width: 460px;
    height: 780px;

    // Hide default Cognigy branding
    #cognigyBrandingLink,
    .webchat-header-cognigy-logo {
        display: none;
    }

    &.webchat {
        border-radius: var(--stamp-radius-s, 6px);
        background: var(--stamp-color-background-variant, #F1F1F2);
        box-shadow: 0px 2px 6px 0px rgba(31, 30, 47, 0.15);

        // Reset
        * {
            border-radius: 0;
        }

        button {
            @include primary-button;
        }
    }

    // Chat container
    .webchat-chat-history {
        outline: none;
        background: var(--stamp-color-background-variant, #F1F1F2);

        * {
            font-family: var(--text-font-family, --text-font-family-fallback);
            font-size: var(--text-default-font-size, 16px);
        }

        #webchatChatHistoryWrapperLiveLogPanel > :nth-child(2) {
          // Sssttt! Don't show second div, which mentioned user is talking to an AI agent. Daan doesn't know...
          display: none;
        }

        article:last-of-type {
            margin-bottom: 8px;
        }
    }

    .webchat-typing-indicator {
        border: none;
        background: none;

        [class^="_dot"] {
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background-color: var(--stamp-color-icon-brand, #E75204);
        }
    }

    // Top bar
    .webchat-header-bar {
        display: flex;
        width: 100%;
        min-height: 56px;
        padding: var(--stamp-spacing-inner-m, 12px) var(--stamp-spacing-inner-xl, 24px);
        justify-content: center;
        align-items: center;
        gap: 93px;
        border-radius: var(--stamp-radius-s, 6px) var(--stamp-radius-s, 6px) 0px 0px;
        border: 0px solid var(--stamp-color-border-default, #BEC0CB);
        background: var(--stamp-color-background-subtle, #DDDEE3);

        .logoNameContainer {
            overflow: hidden;
            color: var(--stamp-color-heading-subtle, #1F1E2F);
            text-align: center;
            text-overflow: ellipsis;
            font-family: var(--stamp-text-body-s-default-font-family, --text-font-family-fallback);
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 105%;
            position: absolute;

            // Container of minimize and close buttons
            + div:has(.webchat-header-close-button) {
                margin-left: auto;

                .webchat-header-minimize-button {
                  background-color: unset;
                  padding: 0;
                  height: auto;
              }

              .webchat-header-close-button {
                    background-color: unset;
                    padding: 0;
                    height: auto;
                }
            }
        }

        svg {
            fill: var(--stamp-color-icon-button-tertiary-default, black);
        }

        button:active svg{
            fill: var(--stamp-color-icon-button-tertiary-pressed, black);
        }
    }

    // Message rows
    .webchat-message-row {
        margin-top: 0;
        margin-left: 16px;
        margin-right: 16px;

        .chat-bubble {
            @include message-border;
            padding: var(--stamp-spacing-inner-m, 12px);
            margin-bottom: var(--stamp-spacing-inner-s, 8px);
        }

        // Bot and CS Agent Messages
        &.bot, &.agent {

            // First chat bubble of consecutive (grouped) messages
            &:not([class*="_collated"]) {
                .chat-bubble, .webchat-list-template-root {
                    border-top-left-radius: 0;
                }
            }

            .message-header {
                column-gap: 8px;
                margin-bottom: var(--stamp-spacing-inner-s, 8px);

                // Hide time indication and seperator
                [class^="_avatar-name"] ~ * {
                    display: none;
                }
            }
        }

        &.bot {
            &:has(+ .bot) {
                margin-bottom: var(--stamp-spacing-inner-s, 8px);
            }
        }

        &.agent {
            &:has(+ .agent) {
                margin-bottom: var(--stamp-spacing-inner-s, 8px);
            }
        }

        // User Messages
        &.user {

            &:has(+ .user) {
                margin-bottom: var(--stamp-spacing-inner-s, 8px);
            }
            // The last of consecutive (grouped) bubbles
            &[class*="_collated"]:not(:has(+ .user)) .chat-bubble,
            &:not([class*="_collated"]):not(:has(+ .user)) .chat-bubble {
                border-bottom-right-radius: 0;
            }

            .message-header {
                display: none;
            }

            .chat-bubble {
                background: var(--stamp-color-background-subtle, #DDDEE3);
            }
        }
    }

    .webchat-quick-reply-template-replies-container {
        margin: var(--stamp-spacing-inner-xl, 24px) 0 0 auto;
        justify-content: end;
        gap: var(--stamp-spacing-inner-s, 8px);
        max-width: 100%;
        padding-left: var(--stamp-spacing-inner-l, 16px);

        .webchat-quick-reply-template-button {
            @include seconday-button;

            &:disabled {
                display: none;
            }
        }
    }

    // Cognigy List
    .webchat-list-template-root {
        @include message-border;
        overflow: auto;
        padding-top: var(--stamp-spacing-inner-m, 12px);

        .webchat-list-template-element-title {
            color: var(--stamp-color-heading-default, #001A73);
            font-family: var(--text-font-family, --text-font-family-fallback);
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 120%;
            margin-bottom: 0;
        }

        .webchat-list-template-element-subtitle {
            color: black;
            font-family: var(--text-font-family, --text-font-family-fallback);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
        }

        .webchat-list-template-element-content, [class^="_buttons"] {
            padding: 0 var(--stamp-spacing-inner-m, 12px);
        }

        button.webchat-list-template-element-button {
            @include seconday-button;
        }

        [class^="_divider"]:not(:has(+ [class*="_mainButtonWrapper"])) {
            display: none;
        }

        [role="listitem"]:has(> [class^="_button"]) {
            margin-bottom: var(--stamp-spacing-inner-xl, 24px);

            .webchat-list-template-element-content {
                margin-bottom: var(--stamp-spacing-inner-l, 16px);
            }
        }

        [role="listitem"] {
            margin-bottom: var(--stamp-spacing-inner-l, 16px);
        }

        :nth-last-child(-n + 1 of div[role="listitem"]) {
            margin-bottom: var(--stamp-spacing-inner-m, 12px);
        }

        [class*="_mainButtonWrapper"] {
            margin: var(--stamp-spacing-inner-m, 12px) 0;

            button {
                @include tertiary-button;
            }
        }
    }

    // In-chat avatars
    .webchat-avatar {
        z-index: 9;
        position: relative;
        width: 0;
        height: 0;
        border-radius: 0;
        padding: 32px 32px 0 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        background-color: unset;

        &.bot {
            background-image:url('data:image/svg+xml,<svg width="27" height="32" viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Basis"><path id="Path" d="M11.7947 31.8932C18.0944 31.7652 27.464 15.8484 26.0581 11.5754C24.6523 7.30231 16.0805 6.58978 16.0805 6.58978C16.0805 6.58978 3.0224 4.88311 0.703471 9.86445C-1.61546 14.8458 7.22507 31.9871 11.7947 31.8932Z" fill="%23FF8D00"/><path id="Path_2" d="M21.32 24.032C24.5456 19.3237 26.8048 13.824 26.0624 11.569C24.6565 7.30237 16.0848 6.58343 16.0848 6.58343C16.0848 6.58343 3.02667 4.87677 0.707733 9.8581L21.32 24.032Z" fill="%23FF5100"/><g id="Oval" style="mix-blend-mode:multiply" opacity="0.7"><path d="M12.9275 23.5071C16.2724 23.5071 18.984 20.7955 18.984 17.4506C18.984 14.1056 16.2724 11.394 12.9275 11.394C9.58254 11.394 6.87094 14.1056 6.87094 17.4506C6.87094 20.7955 9.58254 23.5071 12.9275 23.5071Z" fill="%23D3DAE4"/></g><path id="Path_3" d="M9.16 10.7136C9.16 10.7136 12.4005 9.28213 16.6757 10.7136" stroke="%23FFD800" stroke-width="1.20747"/><path id="Path_4" d="M15.6795 25.4207C14.6128 26.0074 12.2832 26.8735 9.87469 25.1455" stroke="%23000C35" stroke-width="1.13493" stroke-linecap="round"/><g id="Path_5" style="mix-blend-mode:multiply"><path d="M10.7771 7.54565C10.807 7.35365 11.0651 6.96538 12.1275 6.97605C12.9168 6.97605 13.3926 7.41765 13.4438 7.60538L10.7771 7.54565Z" fill="%23E2E1E9"/></g><path id="Path_6" d="M13.1921 7.60101C13.2155 6.77541 13.207 5.55087 12.8913 4.53114C12.7101 3.91177 12.4656 3.3127 12.1617 2.74341" stroke="%231D304C" stroke-width="0.725333"/><path id="Oval_2" d="M12.5755 4.43729C13.7855 4.43729 14.7664 3.45637 14.7664 2.24635C14.7664 1.03633 13.7855 0.0554199 12.5755 0.0554199C11.3654 0.0554199 10.3845 1.03633 10.3845 2.24635C10.3845 3.45637 11.3654 4.43729 12.5755 4.43729Z" fill="%23FF5100"/><path id="Oval_3" d="M12.9275 22.8649C15.9178 22.8649 18.3419 20.4408 18.3419 17.4505C18.3419 14.4602 15.9178 12.0361 12.9275 12.0361C9.93717 12.0361 7.51306 14.4602 7.51306 17.4505C7.51306 20.4408 9.93717 22.8649 12.9275 22.8649Z" fill="white"/><path id="Oval_4" d="M14.1349 19.4646C15.6831 19.4646 16.9381 18.2095 16.9381 16.6614C16.9381 15.1132 15.6831 13.8582 14.1349 13.8582C12.5868 13.8582 11.3317 15.1132 11.3317 16.6614C11.3317 18.2095 12.5868 19.4646 14.1349 19.4646Z" fill="%23000C35"/></g></svg>');
        }

        &.agent {
            background-color: var(--stamp-color-illustration-yellow, #FDD732);
            border-radius: 100%;
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="34" height="40" viewBox="0 0 34 40" fill="none"><g id="Helpdesk vrouw"><g id="Group"><path id="Vector" d="M33.0533 39.2346C33.0533 34.0986 25.7613 29.9359 16.7653 29.9359C7.76934 29.9359 0.477341 34.0986 0.477341 39.2346C0.477341 39.2359 0.477341 39.2386 0.477341 39.2399H0.466675V49.4972H33.0413V39.5852C33.0493 39.4692 33.0547 39.3519 33.0547 39.2346H33.0533Z" fill="%236161FF"/><g id="Group_2"><path id="Vector_2" d="M22.5307 9.62396C25.5565 9.62396 28.0093 7.17108 28.0093 4.14529C28.0093 1.11951 25.5565 -1.33337 22.5307 -1.33337C19.5049 -1.33337 17.052 1.11951 17.052 4.14529C17.052 7.17108 19.5049 9.62396 22.5307 9.62396Z" fill="%230E0F1B"/><g id="Group_3"><g id="Group_4"><path id="Vector_3" d="M21.8713 32.1466C21.9182 30.4852 19.8034 29.0775 17.1476 29.0024C14.4918 28.9273 12.3008 30.2132 12.2538 31.8746C12.2068 33.5359 14.3216 34.9436 16.9774 35.0187C19.6332 35.0938 21.8243 33.8079 21.8713 32.1466Z" fill="%238F4E25"/><path id="Vector_4" d="M21.068 25.0479L21.8707 31.9159L12.264 31.7465L13.2507 24.0305L21.068 25.0479Z" fill="%238F4E25"/></g><g id="Group_5"><path id="Vector_5" d="M25.2328 17.5649C25.3911 11.9684 21.9809 7.33151 17.6159 7.20806C13.2509 7.08461 9.58407 11.5214 9.42579 17.1178C9.26752 22.7143 12.6777 27.3512 17.0427 27.4746C21.4077 27.5981 25.0745 23.1613 25.2328 17.5649Z" fill="%23A86231"/><path id="Vector_6" d="M20.144 18.1946C20.535 18.1946 20.852 17.8776 20.852 17.4866C20.852 17.0955 20.535 16.7786 20.144 16.7786C19.753 16.7786 19.436 17.0955 19.436 17.4866C19.436 17.8776 19.753 18.1946 20.144 18.1946Z" fill="%230E0F1B"/><path id="Vector_7" d="M14.1053 18.1946C14.4964 18.1946 14.8133 17.8776 14.8133 17.4866C14.8133 17.0955 14.4964 16.7786 14.1053 16.7786C13.7143 16.7786 13.3973 17.0955 13.3973 17.4866C13.3973 17.8776 13.7143 18.1946 14.1053 18.1946Z" fill="%230E0F1B"/><path id="Vector_8" d="M25.2413 16.1052C25.2413 16.1052 19.9933 11.6692 12.7973 10.2079C12.7053 10.1892 10.94 11.2719 10.2547 13.2919C8.92934 17.1986 9.55067 18.3239 9.55067 18.3239C9.55067 18.3239 7.66534 14.6492 7.71067 12.6972C7.87334 5.71724 17.0173 2.4719 21.724 5.35724C22.62 5.90657 27.0987 7.88257 26.16 13.8332C25.868 15.6826 25.24 16.1052 25.24 16.1052H25.2413Z" fill="%230E0F1B"/></g></g></g><g id="Group_6"><path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M6.91867 20.5319V26.2865C6.91867 26.5749 7.15697 26.8132 7.44534 26.8132H15.344V27.4879H7.44534C6.78437 27.4879 6.244 26.9475 6.244 26.2865V20.5319H6.91867Z" fill="%23E75204"/><path id="Vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M10.4171 9.13394C8.7229 10.3459 7.66133 12.2357 7.66133 14.9986V16.4546H6.98666V14.9986C6.98666 12.0361 8.1391 9.93396 10.0246 8.58522C11.8929 7.24872 14.4446 6.67725 17.2147 6.67725C19.9847 6.67725 22.5364 7.24872 24.4048 8.58522C26.2902 9.93396 27.4427 12.0361 27.4427 14.9986V16.3759H26.768V14.9986C26.768 12.2357 25.7064 10.3459 24.0122 9.13394C22.3009 7.90977 19.9073 7.35191 17.2147 7.35191C14.5221 7.35191 12.1284 7.90977 10.4171 9.13394Z" fill="%23E75204"/><g id="Group_7"><path id="Vector_9" d="M25.7907 14.6532H25.676C24.863 14.6532 24.204 15.3122 24.204 16.1252V21.2092C24.204 22.0222 24.863 22.6812 25.676 22.6812H25.7907C26.6036 22.6812 27.2627 22.0222 27.2627 21.2092V16.1252C27.2627 15.3122 26.6036 14.6532 25.7907 14.6532Z" fill="%23303DB9"/><path id="Vector_10" d="M26.9173 15.2318C28.8147 15.2318 30.352 16.7691 30.352 18.6665C30.352 20.5638 28.8147 22.1011 26.9173 22.1011" fill="%236161FF"/></g><g id="Group_8"><path id="Vector_11" d="M8.70934 22.6812H8.82401C9.63697 22.6812 10.296 22.0221 10.296 21.2092V16.1252C10.296 15.3122 9.63697 14.6532 8.82401 14.6532H8.70934C7.89638 14.6532 7.23734 15.3122 7.23734 16.1252L7.23734 21.2092C7.23734 22.0221 7.89638 22.6812 8.70934 22.6812Z" fill="%23303DB9"/><path id="Vector_12" d="M7.58401 15.2318C5.68667 15.2318 4.14934 16.7691 4.14934 18.6665C4.14934 20.5638 5.68667 22.1011 7.58401 22.1011" fill="%236161FF"/></g><path id="Vector_13" d="M15.3893 28.9986C16.3923 28.9986 17.2053 28.1855 17.2053 27.1826C17.2053 26.1796 16.3923 25.3666 15.3893 25.3666C14.3864 25.3666 13.5733 26.1796 13.5733 27.1826C13.5733 28.1855 14.3864 28.9986 15.3893 28.9986Z" fill="%230E0F1B"/></g></g><path id="Vector_14" d="M14.636 22.9012C15.66 23.3066 17.5533 23.6519 19.112 23.0026L14.636 22.9012Z" fill="white"/></g></svg>');
            background-size: contain;
        }

        // Name container
        & + div {
            color: var(--stamp-color-heading-subtle, #1F1E2F);
            font-feature-settings: 'ss01' on, 'ss03' on;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 160%;
        }
    }

    // Container user input
    .webchat-input {
        border-top: 1px solid var(--stamp-color-border-default, #BEC0CB);
        border-bottom: none;
        background: var(--stamp-color-background-variant, #F1F1F2);
        padding: var(--stamp-spacing-inner-xL, 24px);
        gap: 10px;

        // Input field
        textarea {
            --line-height: 1.4em;
            --border-width: 1px;
            display: flex;
            padding: var(--stamp-spacing-inner-s, 8px);
            max-height: calc(4 * var(--line-height, 1.4em) + 2 * var(--stamp-spacing-inner-s, 8px) + 2 * var(--border-width, 1px));
            justify-content: center;
            align-items: center;
            flex: 1 0 0;
            align-self: stretch;
            border-radius: 4px;
            border: var(--border-width, 1px) solid var(--stamp-color-border-default, #BEC0CB);
            background: var(--stamp-color-background-surface, #FFF);

            &:hover {
                border: var(--border-width, 1px) solid var(--stamp-color-border-hover, #6161FF);
            }

            &:focus {
                @include button-focus;
            }

            &:disabled {
                background-color: var(--stamp-color-background-disabled, #F1F1F2);
                border: var(--border-width, 1px) solid var(--stamp-color-border-default, #BEC0CB);
                cursor: not-allowed;
            }
        }

        // Send button
        button {
            display: flex;
            position: relative;
            width: 40px;
            padding: var(--stamp-spacing-inner-s, 8px);
            background-color: var(--stamp-color-background-button-primary-default, #6161FF);
            text-decoration: none;

            // Hide default
            svg {
                display: none;
            }

            // Icon
            &::after {
                content: '';
                mask-image: url(https://cdn.postnl.nl/images/icons/svg/paper-plane.svg);
                mask-position: center;
                mask-repeat: no-repeat;
                mask-size: 60%;
                background-color: white;
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
            }
        }

        form {
            align-items: stretch;

            > * {
                min-height: 64px;
            }
        }
    }
}

@media (width <= 880px) {
    [data-cognigy-webchat-root] [data-cognigy-webchat] {
        &.webchat {
            border-radius: 0;
            box-shadow: none;
            width: 100vw;
            height: 100vh;
            width: 100svw;
            height: 100svh;
            position: fixed;
            top: 0;
            left: 0;
        }
    }
}


@media (width <= 327px) {
  .webchat-message-row .chat-bubble {
    width: fit-content;
  }
}

// 576px is the breakpoint WebChat uses to go full-screen
@media (width <= 576px) {
  // Disable scrolling on the body, set its height to just the display port.
  body.webchat-open {
    height: 100dvh;
    overflow: hidden;
  }
}

@import "./styles";
